<template>
  <div class="root">
    <TableBlock
      ref="tableData"
      :columns="cloumn"
      :action="action"
      :param="param"
      :navHeight="300"
    >
      <div class="common-space-between" style="margin-bottom: 10px">
        <div class="common-items-center">
          <InputBlock :showBlock="false" :width="120">
            <el-input
              v-model="param.serialNo"
              style="margin-left: 7px; width: 120px"
              :size="this.$store.state.btnSize"
              placeholder="设备序列号"
            ></el-input>
          </InputBlock>
          <InputBlock title="处理状态" :width="150">
            <el-select
              v-model="param.state"
              placeholder="请选择"
              :size="this.$store.state.btnSize"
            >
              <el-option label="未处理" :value="0" />
              <el-option label="已处理" :value="0" />
            </el-select>
          </InputBlock>
          <InputBlock title="项目" :width="150">
            <el-select
              v-model="param.projectId"
              placeholder="请选择"
              filterable
              remote
              :remote-method="getProject"
              :size="this.$store.state.btnSize"
            >
              <el-option
                v-for="item in this.proList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </InputBlock>
          <InputBlock title="设备类型" :width="150">
            <!-- <el-cascader
                        :options="dataThree"
                        :props="{ checkStrictly: true }"
                        clearable></el-cascader> -->
            <el-select
              v-model="param.deviceTypeId"
              placeholder="请选择"
              ref="selectTree"
            >
              <el-option
                :value="param.deviceTypeId"
                :label="selectName"
                style=""
                hidden
              >
              </el-option>
              <el-tree
                :data="dataThree"
                :props="defaultProps"
                @node-click="handleNodeClick"
              ></el-tree>
            </el-select>
          </InputBlock>
        </div>
      </div>
      <div class="common-space-between">
        <div class="common-items-center">
          <Month
            title="报警时间"
            ref="police"
            :width="150"
            @getDate="getPoliceDate"
          ></Month>
          <Month
            title="处理时间"
            ref="process"
            :width="150"
            @getDate="getProcessDate"
          ></Month>
          <el-button
            class="btn-heigth"
            type="primary"
            icon="el-icon-search"
            :size="this.$store.state.btnSize"
            @click="searchBtn"
            >搜索</el-button
          >
          <el-button
            class="btn-heigth"
            type="danger"
            icon="el-icon-refresh"
            :size="this.$store.state.btnSize"
            @click="resetBtn"
            >重置</el-button
          >
        </div>
      </div>
    </TableBlock>
  </div>
</template>

<script>
import { operate } from "@/utils/config";
import { columns } from "./columns/alarm-list";
import { exportFun, getFun } from "@/utils/httpFun";
import Month from "@/components/component-block/block-month.vue";
import { postFun } from '../../../utils/httpFun';
export default {
  components: {
    Month: Month,
  },
  data() {
    return {
      cloumn: [],
      action: operate.GETDEVICEPOLICEPAGE,
      param: {
        serialNo: null,
        projectId: null,
        startTime: null,
        endTime: null,
        startProcessTime: null,
        endProcessTime: null,
        deviceTypeId: null,
        state: null,
      },
      proList: [],
      devList: [],
      dataThree: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },
  created() {
    this.cloumn = columns(this);
  },
  mounted() {
    this.getDevTree();
    this.getProject();
  },
  methods: {
    getDevTree() {
      getFun(operate.GETDEVICETYPETREE, {}, (res) => {
        console.log("获取设备", res);
        this.dataThree = res.data || [];
      });
    },
    getProject(ev){
        // proList
        postFun(operate.GETPROJECTLIST,{
            param:{
              keyWord:ev
            },
            current:1,
            size:100
        },res=>{
            this.proList = res.data.records || [];
        })
    },
    searchBtn() {
      this.$refs.tableData.getDatas();
    },
    resetBtn() {
      this.param = {
        serialNo: null,
        projectId: null,
        startTime: null,
        endTime: null,
        startProcessTime: null,
        endProcessTime: null,
        deviceTypeId: null,
        state: null,
      };

      this.selectName = null;

      this.$refs.police.clear();
      this.$refs.process.clear();

      this.$refs.tableData.resetHttp();
    },
    //获取时间
    getPoliceDate(ev) {
      this.param.startTime =
        ev.startDate == "" ? "" : ev.startDate;
      this.param.endTime = ev.endDate == "" ? "" : ev.endDate;
    },
    //获取时间
    getProcessDate(ev) {
      this.param.startProcessTime =
        ev.startDate == "" ? "" : ev.startDate;
      this.param.endProcessTime =
        ev.endDate == "" ? "" : ev.endDate;
    },
    //导出
    exportBtn() {
      exportFun(operate.EXPORSEVER, this.param, "服务费充值记录");
    },
    handleNodeClick(ev) {
      this.selectName = ev.name;
      this.param.deviceTypeId = ev.id;
      console.log("======", ev);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input--suffix .el-input__inner {
  height: 32px;
}
</style>